module.exports = __webpack_public_path__ + "img/shouye-zixun-png.e310311f.svg";